import axios from 'axios'
import { $getToken } from '@/helpers'
import { useToastStore, useUserStore } from '@/stores'
import router from '@/router'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_DOMAIN + import.meta.env.VITE_API_BASE,
  responseType: 'json',
})

api.interceptors.request.use((options) => {
  const token = $getToken()

  if (token)
    options.headers.Authorization = token

  options.params = {
    ...options.params,
    // app_platform: isIOS ? 'ios' : 'android',
    app_platform: 'h5',
    app_version: __APP_VERSION__,
  }

  return options
})

api.interceptors.response.use((response) => {
  // Note: HTTP 200 但业务 code 为 401，token 过期
  if (response.data?.code === 401) {
    handleUnauthorized()
    return Promise.reject(response.data)
  }

  if (response.status !== 200)
    return Promise.reject(response.data)

  if (response.data.code !== 200)
    return Promise.reject(response.data)

  return response.data
}, (error) => {
  // HTTP 4xx/5xx，统一处理 401 未授权
  const status = error?.response?.status
  const bodyCode = error?.response?.data?.code
  if (status === 401 || bodyCode === 401) {
    handleUnauthorized()
  }
  return Promise.reject(error?.response?.data || error)
})

function handleUnauthorized() {
  useToastStore().$toast('登录已过期，请重新登录')
  useUserStore().logout()
  // 避免在 login 页重复跳转
  if (router.currentRoute.name !== 'login') {
    router.replace({
      name: 'login',
      query: { r: window.encodeURIComponent(router.currentRoute.fullPath) },
    })
  }
}
